import { render, staticRenderFns } from "./DefaultLayoutSidebarItems.vue?vue&type=template&id=27f4e46e&scoped=true&"
import script from "./DefaultLayoutSidebarItems.vue?vue&type=script&lang=ts&"
export * from "./DefaultLayoutSidebarItems.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultLayoutSidebarItems.vue?vue&type=style&index=0&id=27f4e46e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f4e46e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VExpansionPanels,VList})
